import * as actions from '../actions'

const defaultState = {
    events: [],
    loading: false,
    error: null,
    pagination: {
        total: 0,
        skip: 0,
        limit: 50
    }
}

export default function generativeAIEvents(state = defaultState, action) {
    switch (action.type) {
        case actions.REQUEST_GENERATIVE_AI_EVENTS:
            if (action.error) {
                return {
                    ...state,
                    loading: false,
                    error: action.payload.error || 'Error al cargar eventos de Generative AI'
                }
            } else if (action.payload) {
                return {
                    ...state,
                    loading: false,
                    events: action.payload.data || [],
                    pagination: {
                        ...state.pagination,
                        total: action.payload.total || 0
                    },
                    error: null
                }
            } else {
                return {
                    ...state,
                    loading: true,
                    error: null
                }
            }

        case actions.CLEAN_GENERATIVE_AI_EVENTS:
            return defaultState

        default:
            return state
    }
}
